import { flow, getParentOfType } from 'mobx-state-tree';

import { PassolutionStore } from '../passolution';

export const getOptions = flow(function* (self, lng) {
  try {
    const store = getParentOfType(self, PassolutionStore);
    const params = new URLSearchParams({ lng });

    const response = yield fetch(
      `api/${store.endpoints.options}?${params.toString()}`,
      {
        credentials: 'include',
      },
    );
    const { destinations, nationalities } = yield response.json();

    self.destinations = destinations;
    self.nationalities = nationalities;
  } catch (error) {
    console.error('Error while fetching passolution options!', error);
    self.data = {
      destinations: [],
      nationalities: [],
    };
  }
});
